import { Image } from '@sequencehq/core-components'
import { ReactElement } from 'react'
import { IntegrationServices } from '@sequencehq/api'
import { INTEGRATIONS_CONFIG } from 'modules/Integrations/integrationsConfig/integrations.config'

export function getLogo(
  integrationService: IntegrationServices,
  size = 32
): ReactElement | null {
  const config = INTEGRATIONS_CONFIG[integrationService]

  if (!config) {
    console.error("Integration service doesn't have a logo", integrationService)
    return null
  }

  return (
    <Image src={config.smallLogoUrl} width={`${size}px`} height={`${size}px`} />
  )
}
